











































































































































































































































































































import { computed, ref } from '@vue/composition-api'
import {
  defineClassComponent,
  useApiPlus,
  useHandler,
  useLoadResourceData,
  useShareParams,
} from '@/hooks'
import { devOrProd, loadResourceData, Track } from '@/utils'
import { navigateTo } from '@/router'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '多多同城配送',
        }))
      }

      loading = computed(() => this.apiData.loading)

      apiData = useApiPlus({
        resourceData: () =>
          loadResourceData({
            轮播图: {
              id: '8aaa919b8418a62201841c46becb005f',
            },
            即时配送分类: {
              id: '8aaa84d7840fabc001841805cd830038',
              count: 6,
            },
            推荐分类: {
              id: '8aaa84d7840fabc0018418123885003e',
            },
            特产到家: {
              id: '8aaa84d7840fabc001841817be6d0041',
            },
          }),
      })

      resourceData = computed(() => this.apiData.data.resourceData)

      shareParams = useShareParams(
        devOrProd(
          '8aaa904584192d2501841c607b6a0000',
          '8aaa867a826d85e001841c6f816c0085',
        ),
        true,
      )

      即时配送分类索引 = ref(0)

      即时配送结果列表 = useLoadResourceData(
        () =>
          this.loading.value
            ? null
            : {
                id: this.resourceData.value.即时配送分类[
                  this.即时配送分类索引.value
                ].subTitle,
              },
        '即时配送结果列表',
        true,
      )

      推荐分类索引 = ref(0)

      推荐结果列表 = useLoadResourceData(
        () =>
          this.loading.value
            ? null
            : {
                id: this.resourceData.value.推荐分类[this.推荐分类索引.value]
                  .subTitle,
              },
        '推荐结果列表',
      )

      推荐二级结果列表 = useLoadResourceData(
        () =>
          !this.推荐结果列表.value.length ||
          !this.推荐结果列表.value[0].subTitle
            ? null
            : {
                id: this.推荐结果列表.value[0].subTitle,
              },
        '推荐二级结果列表',
      )

      handleServiceClick = useHandler<'查看更多商家'>({
        查看更多商家: () => {
          navigateTo('InstantDeliveryMartList')
        },
      })
    },
)
